export const FORM_DATA_KEYS_MAP = {
  policyDate: 'policy_date',
  travelType: 'travelType',
  numadults: 'numadults'
}

export const retryCount = 3